import { render, staticRenderFns } from "./RELAtrasoViagens.vue?vue&type=template&id=ee2f11c4&scoped=true&"
import script from "./RELAtrasoViagens.vue?vue&type=script&lang=js&"
export * from "./RELAtrasoViagens.vue?vue&type=script&lang=js&"
import style0 from "./RELAtrasoViagens.vue?vue&type=style&index=0&id=ee2f11c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2f11c4",
  null
  
)

export default component.exports